import { useState, useEffect } from "react";
import API from "../../api2";
import AutoCompleteHelper from "../../Helpers/InputHelpers/AutoCompleteHelper";
import { Box } from "@mui/material";
import useAdminControlsStore from "../../Stores/AdminControlsStore";

function CustomerLocationSelect({ edit, editData = {} }: any) {
    const [customers, setCustomers] = useState<any[]>([]);
    const [locations, setLocations] = useState<any[]>([]);
    const [selectedCustomers, setSelectedCustomers] = useState(editData.customers || []);
    const [selectedLocations, setSelectedLocations] = useState(editData.locations || []);
    const { setUser, user } = useAdminControlsStore();

    useEffect(() => {
        const getLocations = async function () {
            return await API.getLocationsByUser({ id: user.id })
        }
        
        // Only set locations from store if in edit mode
        if (edit) {
            getLocations().then((response) => {
                setUser('locations', response)
                setSelectedLocations(response)
            })
        } else {
            // Clear locations when creating a new user
            setSelectedLocations([])
            setUser('locations', [])
        }
    }, []);

    useEffect(() => {
        async function getCustomers() {
            return await API.getCustomers();
        }
        getCustomers().then((res) => {
            const customersWithIds = res.map((cust: any, index: number) => ({
                ...cust,
                id: cust.customer // Use the customer name as the ID
            }));
            setCustomers(customersWithIds);
        });
        if (edit) {
            setSelectedCustomers([...editData.customers]);
            setSelectedLocations(editData.locations);
        }
    }, []);

    useEffect(() => {
        async function getLocations() {
            if (selectedCustomers.length > 0) {
                const fetchedLocations: any[] = [];
                for (let customer of selectedCustomers) {
                    const res = await API.getLocationsByCustomer(customer);
                    fetchedLocations.push(...res);
                }
                setLocations(fetchedLocations);
            } else setLocations([]);
        }

        getLocations();

        if (selectedCustomers.length > 0) setUser("customers", selectedCustomers);
        else setUser("customers", []);
    }, [selectedCustomers]);


    const handleCustomerChange = (newCustomers: any) => {
        setSelectedCustomers(newCustomers);
        if (setUser) setUser("customers", newCustomers);
    };

    useEffect(() => {
        if (selectedLocations?.length > 0) return setUser("locations", selectedLocations)
        return setUser("locations", [])
    }, [selectedLocations])

    return (
        <>
            {customers.length > 0 &&
                <AutoCompleteHelper
                    name="customer"
                    label="Customer"
                    optionsArray={customers}
                    value={selectedCustomers}
                    setValue={handleCustomerChange}
                    multiple={true}
                />
            }
            {locations.length > 0 &&
                <Box mt={2}>
                    <AutoCompleteHelper
                        name="locationName"
                        label="Storage"
                        optionsArray={locations}
                        value={selectedLocations}
                        setValue={(e: any) => setSelectedLocations(e)}
                        multiple={true}
                    />
                </Box>
            }
        </>
    )
}

export default CustomerLocationSelect;